import {i18n} from "@lingui/core";

import "@formatjs/intl-pluralrules/locale-data/en";
import { messages as en } from "../../../../locales/en/messages.po";
import "@formatjs/intl-pluralrules/locale-data/hr";
import { messages as hr } from "../../../../locales/hr/messages.po";
import {detect, fromNavigator} from "@lingui/detect-locale";

const DEFAULT_FALLBACK = () => 'en';

/**
 * The language the app was last set to, as stored by `useLocale`.
 *
 * The app keeps its preferences under the `locale` key as
 * `{"localeKey":"hr","updated":true}` -- its own format, not a bare language
 * tag -- and Lingui's `fromStorage` cannot read that. It returned the raw JSON
 * string, `detect` took it as the first candidate that was merely non-empty,
 * and the result was then discarded as an unsupported language: the saved
 * language was never restored, and every session started in English whatever
 * the user had chosen.
 */
function storedLocale(): string | undefined {
    try {
        const raw = globalThis.localStorage?.getItem('locale');
        if (!raw) return undefined;

        const parsed = JSON.parse(raw);
        const key = typeof parsed === 'string' ? parsed : parsed?.localeKey;
        return typeof key === 'string' && key.length > 0 ? key : undefined;
    } catch {
        // A corrupt value is no worse than no value.
        return undefined;
    }
}

export const DEFAULT_LOCALE = detect(storedLocale, fromNavigator(), DEFAULT_FALLBACK) || DEFAULT_FALLBACK();

export const localeNames = {
    
    'en': 'English',
    'hr': 'Hrvatski',
}

export const locales = Object.keys(localeNames)

const localeMessages = {
    
    'en': en,
    'hr': hr,
}

function isLanguageCodeSupported(languageCode: string) {
    return locales.includes(languageCode);
}

export const defaultLocale = isLanguageCodeSupported(DEFAULT_LOCALE) ? DEFAULT_LOCALE : DEFAULT_FALLBACK();

export default function activateLocale() {
    i18n.load(localeMessages)
    i18n.activate(defaultLocale, locales);
    return i18n;
}

export function dynamicActivateLocale(locale: string) {
    i18n.activate(locale);
}
